<template>
  <div id="app">
    <navBar class="navbarc"/>
    <router-view ref='routerView' class="routerc"/>
    <page-banner class="banner"/>
    <footer-footer class="footerc"/>
  </div>
</template>

<script>
import $ from
 'jquery';
export default {
  name: 'App'
}
$(function () {
  var lastScrollTop = 0;
  var $navbar = $('.navbarc');
  var lastTime = new Date().getTime();
  var lastOffset=$(this).scrollTop();

  $(window).scroll(function(event){
    var st = $(this).scrollTop();
    var time=event.timeStamp-lastTime;
    var offset=$(this).scrollTop()-lastOffset;
    var speed = Math.abs(Math.floor(10*(offset / time)));
    if(!(st<10)){
      if (st > lastScrollTop && st > 100 && speed>10) {
        $navbar.slideUp("fast");
      }
      if(st < lastScrollTop && speed>8){ 
        $navbar.slideDown("fast");
      }
    }else{
      $navbar.slideDown("fast");
    }
    lastScrollTop = st;
    lastTime=event.timeStamp;
    lastOffset=st;
  });
});
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Fahkwang|Inconsolata|Indie+Flower|K2D|Mali|Roboto+Mono|Slabo+27px');
@import 'assets/css/bootstrap.css';
@import 'assets/css/style.css';

#app {

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 45.6px;
  
}

.banner{
  display:none;
}

.navbarc{
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;

  }
@media (min-width: 913px) {
  .navbarc{
    left:21%;
    width:79%;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .routerc{
    margin-left:21%;
  }
  .footerc{
    margin-left:21%;;
  }

  .banner{
  display:initial;
  position:fixed;
  top:0px;
  left:0px;
  width:20%;
  height:100%;
}
}


</style>



// WEBPACK FOOTER //
// src/App.vue